import React, { useState, useEffect } from 'react';
import BookHighlightManager from '../../services/home/BookHighlightManager';
import SectionHeader from '../../components/home/exploreBooksComponents/SectionHeader';
import BookGrid from '../../components/home/exploreBooksComponents/BookGrid';
import { useSelector } from 'react-redux';

const JustLaunchedBooks = () => {
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState('grid'); // Add view state
  const userId = useSelector(state => state.auth.user?.userId) || null;

  const fetchJustLaunchedBooks = async () => {
    setLoading(true);
    try {
      const launchedBooks = await BookHighlightManager.getJustLaunchedBooks(userId);
      setBooks(launchedBooks);
    } catch (err) {
      console.error("Error fetching just launched books", err.response?.data || err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJustLaunchedBooks();
  }, [userId]);

  const mappedBooks = books.map(b => ({
    id: b.bookId || b.id,
    title: b.bookName || b.title,
    author: b.author?.authorName || b.author,
    isbn: b.bookIsbn13 || b.isbn,
    description: b.bookDescription || " ",
    rating:(b.averageRating || 0),
    image: Array.isArray(b.bookImages) ? b.bookImages[0] : b.image,
    inStock: b.bookStockStatus,
  }));

  return (
    <div className="min-h-screen bg-white">
      <SectionHeader
        title="Just Launched Books"
        placeholder="Search for newly launched books"
        showViewToggle={true} // Optional: to show grid/list toggle in header if implemented there
        view={view}
        onViewChange={setView}
      />

      <div className="container mx-auto px-4 py-2">
        <BookGrid
          books={mappedBooks}
          view={view}
          onViewChange={setView} // Pass to enable toggle
          loading={loading}
        />

        {!loading && books.length === 0 && (
          <div className="mt-6 text-center text-gray-500">
            No new books available.
          </div>
        )}
      </div>
    </div>
  );
};

export default JustLaunchedBooks;
